module.exports = __webpack_public_path__ + "img/1500054468.5817adbb.jpg";